
export const UNINSURED_PRODUCT_TYPE = "1"
export const INSURED_PRODUCT_TYPE = "2"
export const ILK_EVIM_UNINSURED_PRODUCT_TYPE = "3"
export const ILK_EVIM_INSURED_PRODUCT_TYPE = "4"

export const DeviceTypes = {
  MOBILE: "M",
  TABLET: "T",
  DESKTOP: "D",
}

export const FamilyType = [
  {code : 1, title : "KENDİSİ"},
  {code : 2, title : "EŞ"},
  {code : 3, title : "ÇOCUK"},
  {code : 4, title: "EBEVEYN"},
  {code : 5, title: "KARDEŞ"}
]

export const PosCekStatus = {
  ExpiryDatePass : "Transfer Gerçekleşti",
  ExpiryDateWaiting : "Beklemede"
}

export const UNUSED_PRODUCT_TYPE = "1"
export const USED_PRODUCT_TYPE = "2"

export const HAS_ANOTHER_HOUSE = "E"
export const HAS_NOT_ANOTHER_HOUSE = "H"

export const MAX_USED_VALUE_ERROR_CODE = "61"
export const MAX_LTV_VALUE_ERROR_CODE = "AKON_0013"